<template>
	<div class="login-container">
		<!-- 左侧品牌展示区 -->
		<div class="brand-section">
			<img src="../assets/img/login.png" alt="背景" class="background-image">
		</div>

		<!-- 右侧登录区域 -->
		<div class="login-section">
			<div class="login-box">
				<div class="login-header" style="text-align: center;">
					<div class="logo-container">
						<img src="../assets/img/logo.jpg" alt="万里牛" class="logo-image">
						<span class="logo-text">智润易达智饮管理系统</span>
					</div>
					<h3 class="login-title">密码登录</h3>
				</div>

				<el-form ref="form" :model="form" class="login-form">
					<el-form-item>
						<el-input
								v-model="form.account"
								autofocus
								maxlength="24"
								placeholder="请输入手机号/邮箱"
								prefix-icon="el-icon-user">
						</el-input>
					</el-form-item>

					<el-form-item>
						<el-input
								v-model="form.password"
								maxlength="18"
								placeholder="密码"
								type="password"
								show-password
								prefix-icon="el-icon-lock"
								@keyup.enter.native="login">
						</el-input>
					</el-form-item>

					<el-form-item class="remember-section">
						<el-checkbox v-model="form.rememberMe">7天内免登录</el-checkbox>
					</el-form-item>

					<el-form-item class="btn-login-container">
						<el-button type="primary" class="btn-login" @click="login">登 录</el-button>
					</el-form-item>
				</el-form>

				<!-- 底部版权信息 -->
				<div class="footer">
					<div class="contact-info">服务热线: 400-156-1506</div>
					<div class="copyright-info">
						<span>版权所有 © 2024-2025 深圳市智润易达科技有限公司</span>
						<span class="beian-link"><a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2025367264号-1</a></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import {axios} from "../config/axios";
	export default {
		name: 'login',
		data() {
			return {
				form: {
					account: '',
					password: '',
					codeNumber:'',
					rememberMe: false
				},
				identifyCodes: "1234567890",
				identifyCode: "", // 验证码
			}
		},
		mounted() {
			this.identifyCode = "";
			this.makeCode(this.identifyCodes, 4);
		},
		methods: {
			login () {
				localStorage.removeItem("logistics-token"); // 清除缓存影响
				axios.post('user/login',{
					account: this.form.account.trim(),
					password: this.form.password.trim()
				}).then(response => {
					const code = response.code;
					if (code === 200) {
						let role = response.data.role;
						// 获取用户基本信息
						let userInfo = response.data.userInfo;
						let permissionsInfo = response.data.permissions;
						console.info("login==========")
						localStorage.setItem("logistics-token",response.data.token);
						localStorage.setItem("logistics-userInfo",JSON.stringify(userInfo));
						// 将权限数据存储到 localStorage
						localStorage.setItem("logistics-permissions",JSON.stringify(permissionsInfo));
						this.$router.push({
							name: 'home-page',  // 路由的名称
						})
					}else  if(code === 1001){
						this.$message.error('账号不存在！');
					}else if(code === 1003){
						this.$message.error('账号已被禁用！');
					}else{
						this.$message.error('账号或者密码输入有误！');
					}
				})
						.catch(err => {
							console.log(err);
							this.alertMsg();
						});
			},
			cancelLogin(){
				for(let key in this.form){
					this.form[key]  = ''
				}
			},
			alertMsg() {
				this.$notify.error({
					title: '提示',
					message: '网络出现错误!'
				});
			},

			//图片验证码
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min);
			},
			refreshCode() {
				this.identifyCode = "";
				this.makeCode(this.identifyCodes, 4);
			},
			makeCode(o, l) {
				for (let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
							this.randomNum(0, this.identifyCodes.length)
							];
				}
			},
		}
	}
</script>

<style>
	.login-container {
		display: flex;
		height: 100vh;
		width: 100%;
		overflow: hidden;
	}

	/* 左侧品牌展示区 */
	.brand-section {
		flex: 1;
		background: linear-gradient(135deg, #0066FF 0%, #82C6FF 100%);
		position: relative;
		overflow: hidden;
	}

	.brand-section .background-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
	}

	/* 右侧登录区域 */
	.login-section {
		width: 500px;
		background-color: white;
		display: flex;
		flex-direction: column;
		padding: 0 50px;
		box-shadow: -4px 0 10px rgba(0, 0, 0, 0.05);
		position: relative;
	}

	.login-section .login-box {
		width: 100%;
		padding-top: 25vh;
	}

	.login-section .login-header {
		margin-bottom: 40px;
	}

	.login-section .login-header .logo-container {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 30px;
	}

	.login-section .login-header .logo-image {
		width: 40px;
		height: 40px;
		margin-right: 10px;
	}

	.login-section .login-header .logo-text {
		font-size: 24px;
		font-weight: bold;
		color: #146bfa;
	}

	.login-section .login-header .login-title {
		font-size: 20px;
		color: #575757;
		margin: 0;
	}

	.login-section .login-form {
		padding: 0 !important;
		-webkit-box-shadow: none !important;
		box-shadow: none !important;
	}

	.login-section .login-form .el-form-item {
		margin-bottom: 25px;
	}

	.login-section .login-form .el-input {
		height: 48px;
	}

	#app .login-section .login-form .el-input__inner {
		height: 48px;
		line-height: 48px;
		font-size: 16px;
		border: none;
		border-bottom: 1px solid #DCDFE6;
		border-radius: 0;
		background-color: transparent;
		padding-left: 30px;
		transition: all 0.3s;
	}

	#app .login-section .login-form .el-input__inner:focus {
		border-bottom: 2px solid #146bfa;
		box-shadow: none;
	}

	#app .login-section .login-form .el-input__prefix {
		left: 0;
	}

	#app .login-section .login-form .el-input__prefix .el-input__icon {
		font-size: 18px;
		color: #909399;
	}

	#app .login-section .login-form .el-input:hover .el-input__inner {
		border-bottom-color: #146bfa;
	}

	.login-section .login-form .remember-section {
		margin-bottom: 30px;
	}

	.login-section .login-form .btn-login-container {
		margin-top: 10px;
	}

	.login-section .login-form .btn-login-container .btn-login {
		width: 100%;
		height: 50px;
		font-size: 18px;
		background-color: #0066FF;
		border-color: #0066FF;
	}

	.login-section .login-form .btn-login-container .btn-login:hover,
	.login-section .login-form .btn-login-container .btn-login:focus {
		background-color: #0052CC;
		border-color: #0052CC;
	}

	.login-section .footer {
		position: absolute;
		bottom: 30px;
		left: 0;
		right: 0;
		text-align: center;
		font-size: 12px;
		color: #999;
		padding: 0 20px;
	}

	.login-section .footer .contact-info {
		margin-bottom: 5px;
	}

	.login-section .footer .copyright-info {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		gap: 10px;
	}

	.login-section .footer .copyright-info .beian-link a {
		color: #999;
		text-decoration: none;
	}

	.login-section .footer .copyright-info a:hover {
		color: #0066FF;
	}

	@media screen and (max-width: 1200px) {
		.brand-section {
			display: none;
		}

		.login-section {
			width: 100%;
		}
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #0066FF;
		border-color: #0066FF;
	}

	/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
		color: #606266;
	}


	>>> .el-form {
		-webkit-box-shadow: none !important;
		box-shadow: none !important;
	}

	/deep/ .el-form-item__content {
		background-color: transparent;
	}
</style>
